export default __webpack_public_path__ + "static/media/terms-and-conditions-capnobook.970d5f95.pdf";